// src/utils/pkce.js
// PKCE (Proof Key for Code Exchange) utilities for OAuth2 flow

/**
 * Generate a cryptographically random string for use as code_verifier
 * @returns {string} Random string of 43-128 characters
 */
export function generateCodeVerifier() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64URLEncode(array);
}

/**
 * Generate code_challenge from code_verifier using SHA-256
 * @param {string} verifier - The code verifier string
 * @returns {Promise<string>} Base64 URL-encoded SHA-256 hash
 */
export async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await crypto.subtle.digest("SHA-256", data);
  return base64URLEncode(new Uint8Array(hash));
}

/**
 * Base64 URL encode (without padding)
 * @param {Uint8Array} buffer - The buffer to encode
 * @returns {string} Base64 URL-encoded string
 */
function base64URLEncode(buffer) {
  const base64 = btoa(String.fromCharCode(...buffer));
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

/**
 * Generate random state parameter for CSRF protection
 * @returns {string} Random state string
 */
export function generateState() {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
}
